import { render, staticRenderFns } from "./MakinaForm.vue?vue&type=template&id=cedae82e&"
import script from "./MakinaForm.vue?vue&type=script&lang=js&"
export * from "./MakinaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports